'use strict';

import { getLoginRequiredResolveObj } from '../shared/utils/angularUtils';
import { NAVIGATION_ICON } from '../shared/constants/system/navigationIcons';
import { SOLUTION_TYPE } from '../shared/constants/user-info/solutionType';
import { FOOD_TYPE } from './constants/foodType';
import { getHumanizeFoodType } from './utils';

export const foodManagementModule = angular
  .module('app.foodManagement', [])
  .config(foodManagementConfig);

foodManagementConfig.$inject = ['$routeProvider'];

function foodManagementConfig($routeProvider) {
  $routeProvider
    .when('/recipes', {
      template: `<ngz-recipes></ngz-recipes>`,
      resolve: getLoginRequiredResolveObj(),
      pageConfig: {
        solution: SOLUTION_TYPE.NUTRITION,
        breadcrumbs: [
          { label: 'Recipes', icon: NAVIGATION_ICON.MENU_BOOK }
        ]
      }
    });

  [
    { path: '/add-recipe', label: 'Add Recipe' },
    { path: '/add-recipe/:id', label: 'Add Recipe' },
    { path: '/edit-recipe/:id', label: 'Edit Recipe' }
  ].forEach(({ path, label }) => {
    $routeProvider.when(path, {
      template: `<ngz-recipe-form></ngz-recipe-form>`,
      resolve: getLoginRequiredResolveObj(),
      pageConfig: {
        solution: SOLUTION_TYPE.NUTRITION,
        breadcrumbs: [{ label, icon: NAVIGATION_ICON.MENU_BOOK }]
      }
    });
  });

  [
    { foodType: FOOD_TYPE.CORE, icon: NAVIGATION_ICON.GROCERY },
    { foodType: FOOD_TYPE.SUPPLEMENT, icon: NAVIGATION_ICON.PILL },
    { foodType: FOOD_TYPE.VEGGIES, icon: NAVIGATION_ICON.AVOCADO_BEAN },
    { foodType: FOOD_TYPE.BARCODE, icon: NAVIGATION_ICON.BARCODE }
  ].forEach(({ foodType, icon }) => {
    $routeProvider
      .when(`/foods/${foodType}`, {
        template: `<ngz-foods food-type="${foodType}"></ngz-foods>`,
        resolve: getLoginRequiredResolveObj(),
        pageConfig: {
          solution: SOLUTION_TYPE.NUTRITION,
          breadcrumbs: [
            { label: getHumanizeFoodType(foodType, { pluralize: true }), icon }
          ]
        }
      })
      .when(`/add-food/${foodType}`, {
        template: `<ngz-food-form food-type="${foodType}"></ngz-food-form>`,
        resolve: getLoginRequiredResolveObj(),
        pageConfig: {
          solution: SOLUTION_TYPE.NUTRITION,
          breadcrumbs: [{ label: `Add ${getHumanizeFoodType(foodType)}`, icon }]
        }
      })
      .when(`/edit-food/${foodType}/:id`, {
        template: `<ngz-food-form food-type="${foodType}" is-edit="true"></ngz-food-form>`,
        resolve: getLoginRequiredResolveObj(),
        pageConfig: {
          solution: SOLUTION_TYPE.NUTRITION,
          breadcrumbs: [{ label: `Edit ${getHumanizeFoodType(foodType)}`, icon }]
        }
      });
  });
}
